import appConfig from "../app";

const apiConfig = {
    API_URL_AUTH : appConfig.API_URL + "auth/soporte",
};

export default apiConfig;